import { Toast } from 'antd-mobile'
import dayjs from 'dayjs'
import { BtnStatusMap, MarkInfoItemType, SkuInfoItemType, StatusMap, TabItemType } from './types'

// 有副作用
export function getTabItem(it: MarkInfoItemType, index: number): TabItemType {
  const today = dayjs().format('YYYY-MM-DD')
  const date = dayjs(it.begTime).format('YYYY-MM-DD')
  const status = getSnapUpStatus(it)
  return {
    index,
    title: dayjs(it.begTime).format('HH:mm'),
    status,
    date: date === today ? undefined : dayjs(it.begTime).format('MM/DD'),
    venueId: it.venueId,
  }
}

// 有副作用
// TODO use getTabItem
export function getTabListByMarkList(list: MarkInfoItemType[]): TabItemType[] {
  const today = dayjs().format('YYYY-MM-DD')
  return list.map((it, index) => {
    const date = dayjs(it.begTime).format('YYYY-MM-DD')
    return {
      index,
      title: dayjs(it.begTime).format('HH:mm'),
      status: getSnapUpStatus(it),
      date: date === today ? undefined : dayjs(it.begTime).format('MM/DD'),
      venueId: it.venueId,
    }
  })
}

export function checkCurVenueIsEnd(item: MarkInfoItemType) {
  // 买完了 且没有冷冻期
  // 时间结束
  return item.stockFlag === 2 || item.endTime <= Date.now() + 2000
}

export function checkCurVenueIsSaleout(item: MarkInfoItemType) {
  return item.venueSkuInfoList.every((it) => it.stock === 0)
}

// TODO 拆分
export function getRefreshTabListAndMarkInfoList({
  markInfoList,
  tabList,
  index,
  markInfoItem,
}: {
  markInfoList: MarkInfoItemType[]
  markInfoItem: MarkInfoItemType
  tabList: TabItemType[]
  index: number
}): {
  markInfoList: MarkInfoItemType[]
  tabList: TabItemType[]
} {
  const nextMarkInfoList = markInfoList.map((ele, i) => {
    if (index === i) {
      if (markInfoItem.begTime !== ele.begTime || markInfoItem.endTime !== ele.endTime) {
        return {
          ...markInfoItem,
          begTime: ele.begTime,
          endTime: ele.endTime,
        }
      }
      return markInfoItem
    }
    return ele
  })
  const nextTabList = tabList.map((ele, i) => {
    if (i === index) {
      const status = getSnapUpStatus(markInfoItem)
      return {
        ...ele,
        status,
      }
    }
    return ele
  })
  return {
    markInfoList: nextMarkInfoList,
    tabList: nextTabList,
  }
  // return originList.map((ele, i) => {
  //   if () {

  //   }
  // })
}

export function getSnapUpStatus(markItem: MarkInfoItemType) {
  const { begTime, endTime } = markItem
  const now = Date.now()
  // 1. 未开始
  if (now < begTime) {
    return StatusMap.aboutOf
  }
  // 2. 时间结束 本场已结束
  if (now >= endTime) {
    return StatusMap.end
  }
  if (markItem.venueSkuInfoList) {
    // 3. 如果所有商品都被抢光且商品冷冻期已过
    const isSaleOut = markItem.stockFlag === 2
    if (isSaleOut) {
      return StatusMap.over
    }
  }
  // 4. 进行中
  return StatusMap.ing
}

//
export function refreshData() {}

export function getCountDownTime(status: StatusMap, beginTime: number, endTime: number) {
  return status === StatusMap.aboutOf ? beginTime : endTime
}

// 非纯函数
export function getCountDownSeconds(endTime: number, tabStatus?: StatusMap) {
  if (tabStatus && tabStatus === StatusMap.end) {
    return 0
  }
  const now = endTime - Date.now()
  if (now <= 0) {
    return 0
  }
  return Math.floor(now / 1000)
}

export const tabItemWidth = 104

export const refreshGap = 5000

export function getBtnStatus(info: SkuInfoItemType, curItem?: TabItemType): BtnStatusMap {
  if (curItem === undefined) {
    return BtnStatusMap.goBuy
  }
  if (curItem.status === StatusMap.aboutOf) {
    if (info.noticeFlag === 1) {
      return BtnStatusMap.isSetting
    } else {
      // 已设置
      return BtnStatusMap.remind
    }
  }
  if (info.stock > 0) {
    return BtnStatusMap.goBuy
  }
  return BtnStatusMap.saleOver
}

// new

export function getBtnStatusNew(noticeFlag: number, curItem?: TabItemType): number {
  if (curItem.status === StatusMap.aboutOf) {
    if (noticeFlag === 1) {
      return 2
    } else {
      // 已设置
      return 1
    }
  }
  return 3
}

// 轮询接口
type CbReturn<P> = {
  isGoOn: boolean
  params?: P
}

// TODO 轮询错误重试
export function reqPolling<T, P>({
  apiFn,
  initParams,
  cb,
  time,
  errorMsg,
}: {
  apiFn: (p: P) => Promise<T>
  time: number
  cb: (res: T) => CbReturn<P>
  initParams: P
  errorMsg: string
}) {
  let timer: any = null
  const loop = (p: P) => {
    apiFn(p)
      .then((res) => {
        const { isGoOn, params } = cb(res)
        if (isGoOn && params) {
          timer = setTimeout(() => {
            loop(params)
          }, time)
        }
      })
      .catch((error) => {
        Toast.info(errorMsg)
        console.error('error', error)
      })
  }
  loop(initParams)
  return {
    cancel() {
      if (timer !== null) {
        clearTimeout(timer)
      }
    },
  }
}

// // TODO
// function getTabListChangeResult(activeIndex: number, ) {

// }

function tabItemStatus(item: TabItemType) {
  if (item.status === StatusMap.aboutOf) {
    return StatusMap.ing
  }
  if (item.status === StatusMap.ing) {
    return StatusMap.end
  }
  return item.status
}

export function changeTabItemStatus(list: TabItemType[], index: number): TabItemType[] {
  return list.map((ele, i) => {
    if (index === i) {
      return {
        ...ele,
        status: tabItemStatus(ele),
      }
    }
    return ele
  })
}

export function changeSkuInfoNoticeFlag(
  markInfoList: MarkInfoItemType[],
  venueId: number,
  skuId: number
): MarkInfoItemType[] {
  return markInfoList.map((ele) => {
    if (ele.venueId === venueId) {
      return {
        ...ele,
        venueSkuInfoList: ele.venueSkuInfoList.map((it) => {
          if (it.skuId === skuId) {
            return {
              ...it,
              noticeFlag: it.noticeFlag === 1 ? 2 : 1,
            }
          }
          return it
        }),
      }
    }
    return ele
  })
}

export function checkActiveIsEnd(markInfoList: MarkInfoItemType[]): boolean {
  if (markInfoList.length === 0) {
    return true
  }
  if (markInfoList.length === 1) {
    return markInfoList[0].endTime < Date.now()
  }

  return false
}

export function findNextStartTime(curIndex: number, tabList: TabItemType[]) {
  const nextIndex = curIndex + 1
  let time = undefined
  if (nextIndex < tabList.length) {
    const nextItem = tabList[nextIndex]
    // 时间结束 抢购结束
    time = `${nextItem.date || ''} ${nextItem.title}`
  }
  return time
}

export function getInitStateParams(
  oldMarkInfoList: MarkInfoItemType[],
  oldTabList: TabItemType[],
  markInfoList: MarkInfoItemType[]
) {
  let nextMarkInfoList: MarkInfoItemType[] = []
  let nextTabList: TabItemType[] = []
  if (markInfoList.length) {
    nextTabList = getTabListByMarkList(markInfoList)
    nextMarkInfoList = markInfoList
  } else {
    nextTabList = oldTabList.map((ele) => ({ ...ele, status: StatusMap.end }))
    nextMarkInfoList = oldMarkInfoList
  }
  return {
    tabList: nextTabList,
    markInfoList: nextMarkInfoList,
  }
}

// const maxSeconds = 59 + 59 * 60 + 99 * 60 * 60
export const maxSeconds = 359999
